import { SignIn } from '@clerk/clerk-react';
import { useTheme } from '../../contexts/ThemeContext';

export default function LoginPage() {
    const { theme } = useTheme();

    return (
        <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold mb-2">LBA Admin Panel</h1>
                    <p className="text-muted-light dark:text-muted-dark">
                        Sign in with your admin Gmail account
                    </p>
                </div>

                <SignIn
                    appearance={{
                        baseTheme: theme === 'dark' ? 'dark' : 'light',
                        elements: {
                            rootBox: 'mx-auto',
                            card: 'bg-background-light dark:bg-background-dark border border-border-light dark:border-border-dark',
                        },
                    }}
                    redirectUrl="/"
                />
            </div>
        </div>
    );
}

